<template>
  <div 
    v-if="skyline"
    style="position: relative; width: 100%; bottom: -10px; right: 0px; z-index: 1;">
    <router-link :to="{ name: 'khdetail', params: { id: slug }}">
    <v-img 
      style="z-index: 1;" 
      cover 
      max-height="560px" 
      min-height="300px" 
      lazy
      v-if="skyline"
      :src="skyline" 
    /> 
    </router-link>
  </div>
</template>

<script>
export default {
  props: ['skyline', 'slug'],
  data: () => ({
    // images: ['././img/hw_maler.webp', '././img/hwfoto221.webp', '././img/hwfoto221_rot.webp'],
    key: 0,
    timer: null,
    currentIndex: 0,
    item: ''
  }),
  created () {},
  beforeDestroy () {
  },
  computed: {
  },
  components: {},
  mounted () {
  }
}
</script>

<style>
</style>
